module.exports = __webpack_public_path__ + "static/media/social-fisherman-11.f03fe640.jpg";